/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react'
import { Center, Image, Link, Text } from '@chakra-ui/react'

import { useNavigate } from 'react-router-dom'
import urgentPriority from '../assets/images/urgent-priority.svg'
import { InformativeLayer } from 'components/informativeLayer'

const ErrorSubscriptionPage = () => {
  const navigate = useNavigate()

  const messages = {
    TITLE: 'La información no está disponible ',
    SUBTITLE: 'Estamos trabajando para solucionarlo, volvé a intentar más tarde.',
    SUPPORT_LINK: 'Volver al inicio',
  }

  const supportLink = () => (
    <Center w='100%' mt={4}>
      <Link
        className='linkDefault'
        fontFamily='Inter'
        fontSize='14px'
        fontWeight={700}
        lineHeight='20px'
        textDecoration='underline'
        color='blue.500'
        onClick={() => {
          navigate('/suscripcion/datos')
          window.location.reload()
        }}
      >
        {messages.SUPPORT_LINK}
      </Link>
    </Center>
  )

  useEffect(() => () => {
    window.history.replaceState({}, null)
  }, [])

  return (
    <div>
      <InformativeLayer
        title={<Text>{messages.TITLE}</Text>}
        subtitle={<Text>{messages.SUBTITLE}</Text>}
        Image={<Image src={urgentPriority} alt='Lateral image' />}
        support={supportLink()}
      />
    </div>
  )
}

export default ErrorSubscriptionPage
